import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable ,  of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ContestEntry } from 'app/contest/shared/models/contest-entry.model';
import { AuthService } from 'app/core/services/auth/auth.service';
import { BaseAuthService } from 'app/core/services/base-auth.service';
import { Contest } from 'app/shared/models/contest.model';

@Injectable({
  providedIn: 'root',
})
export class ContestService extends BaseAuthService {
  contestEntry: ContestEntry = new ContestEntry('', '', '', '', '', '', '', '', '', '', [], [], '', '');
  private cache: Contest[] = [];

  constructor(protected http: HttpClient, protected authService: AuthService) {
    super(http, authService);
  }

  getContests(parameters: Object, fresh = false): Observable<Contest[]> {
    if (this.cache.length && !fresh) {
      return of(this.cache);
    }
    return this.get('contest', parameters).pipe(
      map(contests => {
        this.cache = [];
        contests.forEach(contest => this.cache.push(Contest.fromObject(contest)));
        return this.cache;
      })
    );
  }

  getContest(slug, fresh = false): Observable<Contest> {
    const needle = this.cache.find(contest => contest.slug === slug);
    if (this.cache.length && !fresh && needle) {
      return of(needle);
    }

    return this.get('contest', { slug }).pipe(map(contests => Contest.fromObject(contests[contests.length - 1])));
  }

  sendContestEntry() {
    const answers = this.contestEntry.questions.reduce((question, v, i) => {
      if (question[i]) {
        return question;
      }
      question[v] = this.contestEntry.answers[i];
      return question;
    }, {});

    return this.get('send_contest_entry', {
      data: JSON.stringify({
        contest: this.contestEntry.contest_id,
        firstname: this.contestEntry.firstName,
        lastname: this.contestEntry.lastName,
        email: this.contestEntry.email,
        address: this.contestEntry.address,
        code_area: this.contestEntry.codeArea,
        city: this.contestEntry.city,
        phone_number: this.contestEntry.phoneNumber,
        answers,
        school_name: this.contestEntry.schoolName,
        classroom: this.contestEntry.classroom
      })
    });
  }
}
